import { readable } from "svelte/store";
export const casestudies = readable([], (set) => {
    fetch('./data/casestudies.json').then((data) => data.json()).then((rec) => {
        const list = rec;
        set(list.sort((a, b) => { return (a.title < b.title) ? -1 : 1; }));
    }).catch(() => {
        set(null);
    });
});
